import css from "./Title.module.scss";

import React, { useEffect, useState } from "react";

export const Title: React.FC<React.PropsWithChildren> = ({ children }) => {
    return <div className={css.Title}>{children}</div>;
};
